<template>
  <div class="hot-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入展示内容" size="small" class="param-input" v-model="param.title" clearable ></el-input>
      <el-select v-model="param.enabled" placeholder="请选择是否生效" size="small" clearable >
        <el-option v-for="item in statues" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="param.linkType" placeholder="请选择跳转类型" size="small" clearable >
        <el-option v-for="item in linkTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="param.type" placeholder="请选择类型" size="small" clearable >
        <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="getList()">搜索</el-button>
      <el-button type="primary" size="small" @click="add('add')">新增快捷搜索</el-button>
    </div>
    <!--数据表格-->
    <el-table height="650" :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="id" width="220" label="ID" align="center"></el-table-column>
      <el-table-column prop="title" min-width="300" label="展示内容" align="center"></el-table-column>
      <el-table-column prop="searchKeyword" min-width="200" label="关键词" align="center"></el-table-column>
      <el-table-column prop="type" width="150" label="类型" align="center">
        <template slot-scope="scope">
          <el-tag type="success">{{getTypeName(scope.row.type)}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="link" min-width="200" label="跳转链接" align="center"></el-table-column>
      <el-table-column prop="linkType" width="100" label="跳转类型" align="center">
        <template slot-scope="scope">
          {{getLinkTypeName(scope.row.linkType)}}
        </template>
      </el-table-column>
      <el-table-column prop="enabled" width="100" label="是否生效" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.enabled">是</el-tag>
          <el-tag v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" width="160" label="更新时间" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" width="160" label="创建时间" align="center">
        <template slot-scope="scope">
          <span> {{(scope.row.createdAt || '未知') |  changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button type="success" size="mini" class="el-icon-edit" @click="add('edit', scope.row)"></el-button>
          <el-button type="danger" size="mini" class="el-icon-delete" @click="remove(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[5, 10, 15, 20, 30, 50]"
      :current-page="param.pageNumber"
      :page-size="param.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 5"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--新增、编辑tag弹窗-->
    <add ref="add" @handlerList="getList"></add>
  </div>
</template>
<script>
import Add from './components/add'
import API from '@/api'

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      tableData: [],
      total: 0,
      // 获取列表参数
      param: {
        pageNumber: 1,
        pageSize: 10,
        title: undefined,
        enabled: undefined,
        type: undefined,
        linkType: undefined,
      },
      statues: [
        { label: '是', value: true },
        { label: '否', value: false},
      ],
      linkTypes: [
        { label: '外部浏览器跳转', value: 1 },
        { label: 'APP内部跳转', value: 2 },
      ],
      types: [
        { label: '置顶-评论', value: 1 },
        { label: '大家都在搜-评论', value: 2 },
      ],
    }
  },
  components: {
    Add
  },
  created() {
    this.getList()
  },
  methods: {
    getTypeName(type) {
      var typeName = "";
      for (const t of this.types) {
        if (t.value === type) {
          typeName = t.label;
          break;
        }
      }
      return typeName;
    },
    getLinkTypeName(linkType) {
      var linkTypeName = "";
      for (const j of this.linkTypes) {
        if (j.value === linkType) {
          linkTypeName = j.label;
          break;
        }
      }
      return linkTypeName;
    },
    // 获取快捷搜索列表
    getList() {
      this.loading = true
      API.getQuickSearchList(this.param).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 新增快捷搜索
    add(type, data) {
      this.$refs.add.open(type, data, this.linkTypes, this.types)
    },
    // 删除快捷搜索
    remove(id) {
      this.$confirm('确定要删除当前快捷搜索吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        API.deleteQuickSearch({ id: id }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '删除成功！',
              type: 'success'
            });
            this.getList()
          } else {
            this.$message.error('删除失败！');
          }
        })
      })
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.param.pageSize = size
      this.param.pageNumber = 1
      this.getList()
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.param.pageNumber = pageNumber
      this.getList(this.param)
    }
  }
}
</script>
